<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm" :inline="true">
      <el-form-item  prop="userId" v-if="adminShow">
        <el-cascader
          :placeholder="$t('app.warningLog.form.companyName')"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userId"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item  prop="type">
        <el-select v-model="queryParams.type" 
        :placeholder="$t('app.warningLog.form.selectRuleType')" 
        clearable
        @change="search"
        >
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">{{ $t('app.common.search') }}</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">{{ $t('app.common.reset') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" border :data="tableData" >
      <el-table-column type="index" :label="$t('app.common.serialNumber')" align="center" width="60"></el-table-column>
      <el-table-column  prop="companyName" :label="$t('app.warningLog.table.companyName')" align="center" width="260" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column  :label="$t('app.warningLog.table.type')" prop="type" align="center" width="220" :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span v-if="row.type =='1'">{{ $t('app.warningLog.type.shutdown') }}</span>
            <span v-if="row.type =='2'">{{ $t('app.warningLog.type.insufficientPackage') }}</span>
            <span v-if="row.type =='3'">{{ $t('app.warningLog.type.packageExpire') }}</span>
          </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('app.warningLog.table.ruleName')" align="center"  width="220" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="num" :label="$t('app.warningLog.table.triggeredCards')" align="center"  width="100" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="platforms" :label="$t('app.warningLog.table.sendMethod')" align="center"  width="220" :show-overflow-tooltip="true" >
          <template slot-scope="scope">
            <el-tag v-for="(item,index) in scope.row.platforms" :key="index" style="margin: 3px;">{{platform(item)}}</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="createTime" :label="$t('app.warningLog.table.triggerTime')" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('app.warningLog.table.triggeredCardNo')" align="center"   width="160" >
        <template slot-scope="scope" >
            <el-button
              size="mini"
              type="text"
              @click="warningCards(scope.row.id)"
            >{{ $t('app.common.view') }}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('app.warningLog.table.sendResult')" align="center" width="160" >
        <template slot-scope="scope" >
            <el-button
              size="mini"
              type="text"
              @click="messageResult(scope.row.id)"
            >{{ $t('app.common.view') }}</el-button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('app.common.operation')" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="success" plain @click="down(scope.row.id)" v-hasPermi="['warning:down']">{{ $t('app.common.download') }}</el-button>
          </template>
        </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <el-dialog :title="cardTitle" :visible.sync="openCard" width="900px"   append-to-body :close-on-click-modal="false">
      <el-table :data="tableCard" border style="width: 95%">
          <el-table-column prop="iccid" label="ICCID" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="msisdn" label="MSISDN" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="operationName" :label="$t('app.common.operator')" align="center"></el-table-column>
        </el-table>
        <pagination
          v-show="totalCard>0"
          :total="totalCard"
          :page.sync="cardPage"
          :limit.sync="cardPageSize"
          @pagination="warningDetailData"
          @changePageNo="handleCardCurrentChange"
          @changePageSize="handleCardSizeChange"
        />
    </el-dialog>
    <el-dialog :title="warningMessage" :visible.sync="openMessage" width="900px"   append-to-body :close-on-click-modal="false">
      <el-table :data="tableWarningMessage" border style="width: 95%">
          <el-table-column prop="name" :label="$t('app.warningLog.table.pushMethod')" align="center" width="220" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="status" :label="$t('app.warningLog.table.pushResult')" align="center" width="220" :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span v-if="row.status =='1'">{{ $t('app.common.success') }}</span>
                <span v-if="row.status =='0'">{{ $t('app.common.fail') }}</span>
              </template>
          </el-table-column>
          <el-table-column prop="reason" :label="$t('app.warningLog.table.failReason')" align="center"></el-table-column>
        </el-table>
        <pagination
          v-show="totalMessage>0"
          :total="totalMessage"
          :page.sync="messagePage"
          :limit.sync="messagePageSize"
          @pagination="warningMessageData"
          @changePageNo="handleMessageCurrentChange"
          @changePageSize="handleMessageSizeChange"
        />
    </el-dialog>
  </div>
</template>

<script>
import {warningPage,warningCardPage,warningMessagePage} from "@/api/api"; //消息列表
import { agentTreeList } from "@/api/api.js"; //代理商
export default {
  name:'warningLog',
  data() {
    return {
      // 遮罩层
      loading: true,
      // 搜索
      queryParams:{
        userId:undefined,
        type:undefined,
      },
      agentTree:[],
      types:[
          {
            value:1,
            label:this.$t('app.warningLog.type.shutdown')
          },
          {
            value:2,
            label:this.$t('app.warningLog.type.insufficientPackage')
          },
          {
            value:3,
            label:this.$t('app.warningLog.type.packageExpire')
          }
      ],
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      cardTitle:this.$t('app.warningLog.dialog.triggeredCardTitle'),
      warningId:undefined,
      openCard:false,
      tableCard:[],
      totalCard:0,
      cardPageSize:10,
      cardPage:1,
      warningMessage:this.$t('app.warningLog.dialog.sendResultTitle'),
      openMessage:false,
      tableWarningMessage:[],
      totalMessage:0,
      messagePage:1,
      messagePageSize:10,
    };
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
  },
  methods: {
    handleCardSizeChange(pageSize) {
      this.cardPageSize = pageSize;
      this.warningDetailData();
    },
    handleCardCurrentChange(page) {
      this.cardPage = page;
      this.warningDetailData();
    },
    handleMessageSizeChange(pageSize) {
      this.messagePageSize = pageSize;
      this.warningDetailData();
    },
    handleMessageCurrentChange(page) {
      this.messagePage = page;
      this.warningDetailData();
    },
    //代理商下拉列表
    handleAgentTreeList() {
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    platform(key) {
      let obj = {
        1: this.$t('app.warningLog.platform.platformAlert'),
        2: this.$t('app.warningLog.platform.smsAlert'),
        3: this.$t('app.warningLog.platform.officialAccountAlert'),
      };
      return obj[key];
    },
    initData() {
      this.loading = true;
      let params = {
        model:{
          ...this.queryParams
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      warningPage(params).then(res => {
        this.loading = false;
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        }
      });
    },
    // 页面跳转
    handleClick(routerPath){
      this.$router.push(routerPath);
    },
    /** 搜索按钮操作 */
    search() {
      this.page = 1,
      this.initData();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    // 详情
    messageResult(id) {
      this.warningId = id;
      this.openMessage = true;
      this.warningMessageData();
    },
    warningCards(id){
      this.warningId = id;
      this.openCard = true;
      this.warningDetailData();
    },
    warningDetailData(){
      let params = {
        model:{
          warningId:this.warningId
        },
        page: this.cardPage,
        pageSize: this.cardPageSize,
      };
      warningCardPage(params).then(res => {
          this.loading = false;
          if (res.data.code == 200) {
            this.tableCard = res.data.data.records;
            this.totalCard = res.data.data.total;
          }
        });
        
    },
    warningMessageData(){
      let params = {
        model:{
          warningId:this.warningId
        },
        page: this.messagePage,
        pageSize: this.messagePageSize,
      };
      warningMessagePage(params).then(res => {
          this.loading = false;
          if (res.data.code == 200) {
            this.tableWarningMessage = res.data.data.records;
            this.totalMessage = res.data.data.total;
          }
        });
        
    },
    down(id){
      this.download('warning/down', {id:id}, `预警卡号_${new Date().getTime()}.xlsx`);
    }
  },
  created() {
    this.initData();
    if(this.adminShow){
      this.handleAgentTreeList();
    }
  },
  mounted() {}
};
</script>